'use strict';
const {loadVideoPlayer} = require('../../assets/js/utils/loadLargeLibraries.js');

(function() {
  var module = angular.module('client.components');

  controller.$inject = ['$scope', '$log', '$q', 'User', 'HelpVideoService'];

  function controller ($scope, $log, $q, User, HelpVideoService) {
    var ctrl = this;
    let destroyed = false;
    let pendingVideo = null;

    ctrl.player = null;
    ctrl.options = {
      fluid: true,
      controls: true,
      aspectRatio: '16:9',
      autoplay: false,
      sources: []
    };

    function videoEnded() {
      var currentVideoUrl = ctrl.player.currentSrc();
      var currentVideoIndex = ctrl.videos.findIndex(function(video) { return video.video_url === currentVideoUrl; });
      if (currentVideoIndex != -1 && currentVideoIndex < ctrl.videos.length - 1) {
        ctrl.player.src({src: ctrl.videos[currentVideoIndex + 1].video_url, type: 'video/mp4'});
        ctrl.player.play();
        ctrl.videos[currentVideoIndex].playing = false;
        ctrl.videos[currentVideoIndex + 1].playing = true;
        ctrl.videoTitle = ctrl.videos[currentVideoIndex + 1].name;
        ctrl.videoDescription = ctrl.videos[currentVideoIndex + 1].description;
      }
    }

    ctrl.onChangedVideo = function(video) {
      if (!ctrl.player) {
        pendingVideo = video;
        const currentVideo = ctrl.videos.find(function(candidate) { return candidate.playing; });
        if (currentVideo) {
          currentVideo.playing = false;
        }
        video.playing = true;
        ctrl.videoTitle = video.name;
        ctrl.videoDescription = video.description;
        return;
      }
      var currentVideoUrl = ctrl.player.currentSrc();
      var currentVideoIndex = ctrl.videos.findIndex(function(video) { return video.video_url === currentVideoUrl; });
      if (currentVideoIndex != -1) {
        ctrl.videos[currentVideoIndex].playing = false;
        ctrl.videoTitle = video.name;
        ctrl.videoDescription = video.description;
      }
    };

    ctrl.$onInit = function () {
      // Keep the catalog independent from the on-demand Video.js download.
      HelpVideoService.getVideos(User.getId()).then(function(videos) {
        if (destroyed) {
          return;
        }
        ctrl.videos = videos;
        if (ctrl.videos && ctrl.videos.length) {
          ctrl.options.sources.push({src: ctrl.videos[0].video_url, type: 'video/mp4', poster: ctrl.videos[0].video_thumb});
          ctrl.options.poster = ctrl.videos[0].video_thumb;
          ctrl.videos[0].playing = true;
          ctrl.videoTitle = ctrl.videos[0].name;
          ctrl.videoDescription = ctrl.videos[0].description;
        }
        $q.when(loadVideoPlayer()).then(function(videojs) {
          if (destroyed) {
            return;
          }
          ctrl.player = videojs('helpvideo', ctrl.options, function onPlayerReady() {
            this.on('ended', videoEnded);
          });
          if (pendingVideo) {
            ctrl.player.src({src: pendingVideo.video_url, type: 'video/mp4'});
            ctrl.player.play();
            pendingVideo.playing = true;
            pendingVideo = null;
          }
        }, function(error) {
          if (!destroyed) {
            $log.error('Failed to load the Help Video Library player:', error);
          }
        });
      });
    };

    ctrl.$onDestroy = function () {
      destroyed = true;
      if (ctrl.player) {
        ctrl.player.dispose();
        ctrl.player = null;
      }
    };
  }

  module.component('xpHelpVideos', {
    template: require('./helpVideos.jade'),
    controller: controller,
  });
})();
